import * as yup from 'yup';

export const TemplatePhaseValidationSchema = yup.object({
  title: yup.string().required('Please fill phase title!'),
  color: yup.string().required('Please select phase color!'),
});
